import { BreadcrumbItemType } from 'antd/es/breadcrumb/Breadcrumb';
import { AppBreadcrumb, AppButton, AppCard, AppContainer } from '../atoms';
import { useNavigate, useParams } from 'react-router-dom';
import { Insurer } from '@/types/admin-insurer';
import { AdminInsurerInfo } from '../organisms';
import { EditFill } from '../atoms/AppIcon';
import { AuditInfo } from '../molecules';

interface AdminInsurerDetailTemplateProps {
  breadcrumbItems: BreadcrumbItemType[];
  data: Insurer;
}

const AdminInsurerDetailTemplate = ({ breadcrumbItems, data }: AdminInsurerDetailTemplateProps) => {
  const { site, id } = useParams<{ site: string; id: string }>();
  const currentSite = site ?? 'medix';
  const navigate = useNavigate();

  return (
    <AppContainer className="space-y-5">
      <AppBreadcrumb items={breadcrumbItems} />

      <AppCard title={`保険者詳細:${id}`}>
        <AdminInsurerInfo data={data} />
        <AuditInfo
          createdBy={data?.created_by}
          updatedBy={data?.updated_by}
          updatedAt={data?.updated_at}
        />
        <div className="mt-5 flex gap-2">
          <AppButton
            type="primary"
            icon={<EditFill />}
            onClick={() => navigate(`/${currentSite}/admin/insurers/${id}/edit`)}
          >
            編集
          </AppButton>
        </div>
      </AppCard>
    </AppContainer>
  );
};

export default AdminInsurerDetailTemplate;
